/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./TheSideNav.vue?vue&type=template&id=a385f568"
import script from "./TheSideNav.ts?vue&type=script&lang=ts&external"
export * from "./TheSideNav.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports